import { Component, OnInit } from "@angular/core";
import { FirebaseService, AuthService } from "src/app/core";

@Component({
  selector: "ll-period-totals-card",
  templateUrl: "./period-totals-card.component.html",
  styleUrls: ["./period-totals-card.component.scss"]
})
export class PeriodTotalsCardComponent implements OnInit {
  constructor(private fb: FirebaseService, 
              private auth: AuthService) {}

  ngOnInit() {this.updateClassName();}

  updateClassName(){
    if(this.isAdmin){
      document.getElementById("period-totals").className = "period-totals-grid-a";
    }else{
      document.getElementById("period-totals").className = "period-totals-grid-o";
      
    }
  }

  get isAdmin(): boolean{
    return this.auth.admin;
  }

  mask(num: number): string {
    if (num > 100000) return "$" + (num / 1000).toFixed(0) + "K";
    else if (num > 1000) return "$" + (num / 1000).toFixed(1) + "K";
    return "$" + num.toFixed(2);
  }

  get isLoading(): boolean {
    return this.fb.analytics == null;
  }
  get revenue() {
    return this.fb.analytics.revenue;
  }
  get unitsSold() {
    return this.fb.analytics.unitsSold;
  }
  get newCustomers() {
    return this.fb.analytics.newCustomers;
  }
  get uniqueCustomers() {
    return this.fb.analytics.uniqueCustomers;
  }
  get activeVenues(): number {
    return this.fb.analytics.periodTotals.active_venues;
  }
}
